import { GridRow } from '@shared';
import { Restaurant } from './restaurant.model';

export class GridRowRestaurant extends GridRow(Restaurant) {}
